import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
  Modal,
  Tag,
} from "antd";
import GenericTable from "../../components/Commons/Table/generic-table.component";
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import ShowDataLength from "../../components/Commons/Table/results-length-table.component";
import { useEffect, useState } from "react";
import {
  getAll,
  remove,
  importContracts,
  updateStatus,
} from "../../services/contracts.service";
import { PaginationProps } from "antd/lib";
import { FilterValue } from "antd/es/table/interface";
import { useNavigate } from "react-router-dom";
import { AlertService } from "../../services/alert.service";
import { useMutation, useQuery } from "react-query";
import ConfirmModal from "../../components/Commons/Modal/confirm-modal.component";
import ProfilePermissionService from "../../services/profilePermissions.service";
import { isMobile } from "react-device-detect";
import { formatCurrency } from "../../services/utils";
import { paymentMethods } from "../../Enums/PaymentMethod.enums";
import { contractsStatus } from "../../Enums/ContractsStatus.enums";
import ExportBtn from "../../components/Commons/Export/ExportButton";
import { downloadExcel } from "../../services/utils";
import moment from "moment";
import FilterButton from "../../components/Commons/Table/FilterButton";
import { getAll as loadCustomers } from "../../services/customers.service";
import { RangePickerProps } from "antd/lib/date-picker";
import DetailContract from "./Detail";
import ImportBtn from "../../components/Commons/Import/ImportButton";
import { frequencies } from "../../Enums/Frequency.enums";
import { contractsRepeat } from "../../Enums/ContractsRepeat.enums";
import { getAccountDetails } from "../../services/accounts.service";
import dayjs from "dayjs";

const { Search } = Input;

export default function List() {
  const [contracts, setContracts] = useState([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number | undefined>(10);
  const [total, setTotal] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [order, setOrder] = useState<string>("created_at-desc");
  const [removeContract, setRemoveContract] = useState<any | undefined>(
    undefined
  );
  const [customers, setCustomers] = useState<any[]>([]);
  const [customerId, setCustomerId] = useState<any>();
  const [paymentMethod, setPaymentMethod] = useState<any>();
  const [startDate, setStartDate] = useState<string>(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<string>(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [contractsToExport, setContractsToExport] = useState([]);
  const [exportIsLoading, setExportIsLoading] = useState<boolean>(false);
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [details, setDetails] = useState<any>(null);
  const [openChangeStatus, setOpenChangeStatus] = useState<boolean>(false);
  const [contractToChangeStatus, setContractToChangeStatus] = useState<
    any | undefined
  >(undefined);
  const [allowedPaymentMethods, setAllowedPaymentMethods] =
    useState<any[]>(paymentMethods);

  const [formSearch] = Form.useForm();
  const [formFilter] = Form.useForm();
  const [formChangeStatus] = Form.useForm();

  const navigate = useNavigate();

  const profilePermissionService = ProfilePermissionService.getInstance();

  const { isLoading: contractLoading, refetch: loadContracts } = useQuery(
    [
      "loadContracts",
      currentPage,
      search,
      order,
      perPage,
      customerId,
      paymentMethod,
      startDate,
      endDate,
    ],
    () =>
      getAll({
        page: currentPage,
        per_page: perPage,
        order,
        search,
        customer_id: Number(customerId),
        payment_method: paymentMethod,
        period: startDate && endDate ? `${startDate}, ${endDate}` : undefined,
        date: startDate && !endDate ? startDate : undefined,
      }),
    {
      onSuccess: (response) => {
        setContracts(
          response.data.map((contract: any) => {
            return {
              key: contract.data.id,
              ...contract.data,
            };
          })
        );

        setContractsToExport([]);
        setCurrentPage(response.meta.current_page);
        setPerPage(response.meta.per_page);
        setTotal(response.meta.total);
      },
      refetchOnWindowFocus: false,
    }
  );

  useQuery(["loadCustomers"], () => loadCustomers({ status: "active" }), {
    onSuccess: (response) => {
      setCustomers(
        response.data.map((customer: any) => {
          return {
            key: customer.data.id,
            value: customer.data.id,
            label: customer.data.name,
          };
        })
      );
    },
    refetchOnWindowFocus: false,
  });

  useQuery(["getAccountDetails"], () => getAccountDetails(), {
    onSuccess: (response) => {
      const settings =
        typeof response?.data?.settings === "string"
          ? JSON.parse(response?.data?.settings)
          : response?.data?.settings || {};
      const allowed = paymentMethods.filter((m) =>
        (settings?.payment_methods || []).includes(m.value)
      );
      setAllowedPaymentMethods(allowed.length ? allowed : paymentMethods);
    },
    refetchOnWindowFocus: false,
  });

  const { refetch: loadContractsToExport } = useQuery(
    ["loadContractsToExport"],
    () =>
      getAll({
        order,
        search,
        customer_id: Number(customerId),
        payment_method: paymentMethod,
        period: startDate && endDate ? `${startDate}, ${endDate}` : undefined,
        date: startDate && !endDate ? startDate : undefined,
      }),
    {
      onSuccess: (response) =>
        setContractsToExport(onMapDataToExport(response.data)),
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );

  const { mutate: removeContractMutate } = useMutation(remove, {
    onSuccess: () => {
      AlertService.sendAlert([{ text: "Contrato apagada com sucesso." }]);

      setRemoveContract(undefined);

      if (contracts.length === 1 && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      } else {
        loadContracts();
      }
    },
    onError: () => setRemoveContract(undefined),
  });

  const { mutate: updateContractStatus, isLoading: updateStatusLoading } =
    useMutation(updateStatus, {
      onSuccess: () => {
        AlertService.sendAlert([{ text: "Status atualizado com sucesso." }]);
        setOpenChangeStatus(false);
        setContractToChangeStatus(undefined);
        formChangeStatus.resetFields();
        loadContracts();
      },
      onError: () => {
        AlertService.sendAlert([
          { text: "Falha ao atualizar status.", type: "error" },
        ]);
      },
    });

  const onSearch = (search_value: any) => {
    setCurrentPage(1);
    setSearch(search_value);
  };

  const onFilter = () => {
    setCurrentPage(1);
    setCustomerId(formFilter.getFieldValue("filter_customer"));
    setPaymentMethod(formFilter.getFieldValue("filter_payment_method"));

    const rangeDate = formFilter.getFieldValue("filter_date_range");

    if (rangeDate && rangeDate.length === 2) {
      setStartDate(rangeDate[0].format("YYYY-MM-DD"));
      setEndDate(rangeDate[1].format("YYYY-MM-DD"));
    } else {
      setStartDate("");
      setEndDate("");
    }
  };

  const onClearFilters = () => {
    setCurrentPage(1);
    setCustomerId("");
    setPaymentMethod("");
    setStartDate("");
    setEndDate("");
    formFilter.setFieldValue("filter_date_range", null);
  };

  const disabledStartDate: RangePickerProps["disabledDate"] = (current) => {
    let endDate = formFilter.getFieldValue("filter_end_date");

    if (endDate) {
      return current >= endDate;
    }

    return false;
  };

  const disabledEndDate: RangePickerProps["disabledDate"] = (current) => {
    let startDate = formFilter.getFieldValue("filter_start_date");

    if (startDate) {
      return current <= startDate;
    }

    return false;
  };

  const handleTableChange = (
    pagination: PaginationProps,
    filters: Record<string, FilterValue | null>,
    sorter: any
  ) => {
    if (pagination.current != currentPage) {
      setCurrentPage(Number(pagination.current));
    }

    if (pagination.pageSize != perPage) {
      setPerPage(pagination.pageSize);
      setCurrentPage(1);
    }

    if (sorter.order) {
      let orderBy = `${sorter.field}-${sorter.order.substr(
        0,
        sorter.order.length - 3
      )}`;

      if (order != orderBy) {
        setOrder(orderBy);
      }
    }
  };

  const toPage = (page: string, contract_uuid: string = "") => {
    let pages = {
      create: `/contracts/create`,
      edit: `/contracts/${contract_uuid}/edit`,
      duplicate: `/contracts/${contract_uuid}/duplicate`,
    };

    navigate(pages[page as keyof typeof pages]);
  };

  const onOpenDetails = (record: any) => {
    setDetails(record);
    setOpenDetails(true);
  };

  const onCloseDetails = () => {
    setOpenDetails(false);
    setDetails(null);
  };

  const onOpenChangeStatus = (record: any) => {
    setContractToChangeStatus(record);
    setOpenChangeStatus(true);
    formChangeStatus.setFieldsValue({
      status: record.status,
      status_reason: "",
    });
  };

  const onSubmitChangeStatus = () => {
    formChangeStatus
      .validateFields()
      .then((values) => {
        if (!contractToChangeStatus?.uuid) return;
        updateContractStatus({
          values,
          uuid: contractToChangeStatus.uuid,
        });
      })
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  const statusColor = {
    Active: "#76c12b",
    Inactive: "#e59401",
    Canceled: "#d9421d",
  };

  const columns: any = [
    {
      title: "Plano",
      dataIndex: ["plan", "name"],
      sorter: true,
      key: "plan",
      responsive: ["md", "lg", "xl"],
      width: 150,
    },
    {
      title: "Cliente",
      dataIndex: ["customer", "name"],
      sorter: true,
      key: "customer",
      width: 250,
    },
    {
      title: "Início",
      dataIndex: "start_date",
      sorter: true,
      key: "start_date",
      width: 110,
      render: (_: any, record: any) =>
        record.start_date
          ? moment(record.start_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
    },
    {
      title: "Fim",
      dataIndex: "end_date",
      sorter: true,
      key: "end_date",
      width: 130,
      render: (_: any, record: any) =>
        record.end_date
          ? moment(record.end_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "Indeterminado",
    },
    {
      title: "Emissão",
      dataIndex: "billing_date",
      sorter: true,
      key: "billing_date",
      width: 110,
      render: (_: any, record: any) =>
        record.billing_date
          ? moment(record.billing_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
    },
    {
      title: "Frequência",
      dataIndex: "frequency",
      sorter: true,
      key: "frequency",
      width: 110,
      render: (_: any, record: any) =>
        frequencies.find((frequency) => frequency.value === record.frequency)
          ?.label || "",
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Meio de Pagamento",
      dataIndex: "payment_method",
      sorter: true,
      key: "payment_method",
      width: 110,
      render: (_: any, record: any) =>
        paymentMethods.find((method) => method.value === record.payment_method)
          ?.label || "",
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Valor",
      key: "total_amount",
      dataIndex: "total_amount",
      sorter: true,
      width: 150,
      render: (_: any, record: any) => formatCurrency(record.total_amount || 0),
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Situação",
      key: "status",
      dataIndex: "status",
      sorter: true,
      width: 130,
      render: (_: any, record: any) => (
        <Badge
          color={statusColor[record.status as keyof typeof statusColor]}
          text={
            contractsStatus.find((_status) => _status.value === record.status)
              ?.label || ""
          }
        />
      ),
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Ações",
      key: "action",
      fixed: isMobile ? undefined : "right",
      render: (_: any, record: any) =>
        profilePermissionService.hasPermission(`contracts-contracts:write`) && (
          <Space size="small" direction={isMobile ? "vertical" : "horizontal"}>
            <Tooltip placement="top" title="Detalhes">
              <Button
                type="default"
                shape="circle"
                size="middle"
                icon={<EyeOutlined />}
                onClick={() => onOpenDetails(record)}
              />
            </Tooltip>

            <Tooltip placement="top" title="Duplicar">
              <Button
                type="default"
                shape="circle"
                size="middle"
                icon={<CopyOutlined />}
                onClick={() => toPage("duplicate", record.uuid)}
              />
            </Tooltip>

            <Tooltip placement="top" title="Alterar status">
              <Button
                type="default"
                shape="circle"
                size="middle"
                icon={<RetweetOutlined />}
                onClick={() => onOpenChangeStatus(record)}
              />
            </Tooltip>

            <Tooltip placement="top" title="Editar">
              <Button
                type="default"
                shape="circle"
                size="middle"
                icon={<EditOutlined />}
                onClick={() => toPage("edit", record.uuid)}
              />
            </Tooltip>

            <Tooltip placement="top" title="Apagar">
              <Button
                type="default"
                shape="circle"
                size="middle"
                icon={<DeleteOutlined />}
                onClick={() => setRemoveContract(record)}
              />
            </Tooltip>
          </Space>
        ),
      width: isMobile ? 20 : 220,
    },
  ];

  const filters = (
    <Form
      form={formFilter}
      name="filter_contracts"
      layout="vertical"
      className="form_filter_horizontal"
      autoComplete="off"
      style={isMobile ? {} : { width: 300 }}
    >
      <Row gutter={20} style={{ width: "100%" }}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
        >
          <Form.Item
            label="Data"
            name="filter_date_range"
            className="item_filter"
          >
            <DatePicker.RangePicker
              size="large"
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
        >
          <Form.Item
            label="Cliente"
            name="filter_customer"
            className="item_filter"
          >
            <Select
              placeholder="Todas"
              value={customerId}
              style={{ width: "100%" }}
              options={customers}
              size="large"
            />
          </Form.Item>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
        >
          <Form.Item
            label="Meio de Pagamento"
            name="filter_payment_method"
            className="item_filter"
          >
            <Select
              placeholder="Todas"
              value={paymentMethod}
              style={{ width: "100%" }}
              options={allowedPaymentMethods}
              size="large"
            />
          </Form.Item>
        </Col>

        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 24 }}
          lg={{ span: 24 }}
          xl={{ span: 24 }}
        >
          <Button onClick={onFilter} size="large">
            Filtrar
          </Button>

          {(customerId || paymentMethod || startDate || endDate) && (
            <Button type="link" onClick={onClearFilters} size="large">
              Limpar
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  );

  const exportData = () => downloadExcel(contractsToExport, "Contratos");

  const onMapDataToExport = (data: any) => {
    return data.map((record: any) => {
      return {
        Cliente: record.data.customer.name,
        Plano: record.data.plan.name,
        "Data Início": record.data.start_date
          ? moment(record.data.start_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        "Data Fim": record.data.end_date
          ? moment(record.data.end_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        Situação:
          contractsStatus.find(
            (_status) => _status.value === record.data.status
          )?.label || "",
        Vendedor: record.data.seller.name,
        "Data Emissão": record.data.billing_date
          ? moment(record.data.billing_date, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
        Frequência:
          frequencies.find(
            (frequency) => frequency.value === record.data.frequency
          )?.label || "",
        Repetição:
          contractsRepeat.find((repeat) => repeat.value === record.data.repeat)
            ?.label || "",
        "Valor Total": formatCurrency(record.data.total_amount || 0),
        Desconto: record.data.discount || 0,
        "Meio de Pagamento":
          paymentMethods.find(
            (method) => method.value === record.data.payment_method
          )?.label || "",
        Serviços: record.data.contractServices
          .map((contractService: any) => {
            return `${contractService.service.name} (Qtd: ${
              contractService.quantity
            }, Valor: ${formatCurrency(contractService.price)})`;
          })
          .join("; "),
      };
    });
  };

  useEffect(() => {
    if (contractsToExport.length) {
      exportData();
    }

    setExportIsLoading(false);
  }, [contractsToExport]);

  useEffect(() => {
    formFilter.setFieldsValue({
      filter_date_range: null,
    });
  }, []);

  useEffect(() => {
    formFilter.setFieldsValue({
      filter_date_range:
        startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null,
    });

    if (!startDate || !endDate) {
      formFilter.setFieldValue("filter_date_range", null);
    }
  }, [startDate, endDate]);

  return (
    <>
      <Card styles={{ body: { padding: 8 } }}>
        <Row>
          <Col
            lg={{ span: 12 }}
            md={{ span: 12 }}
            sm={{ span: 24 }}
            xs={{ span: 24 }}
          >
            <Form
              form={formSearch}
              name="search_contracts"
              layout="vertical"
              autoComplete="off"
            >
              <Form.Item name="search_contract">
                <Search
                  onSearch={onSearch}
                  placeholder="Pesquisar contrato"
                  enterButton="Pesquisar"
                  allowClear
                  size="large"
                  maxLength={255}
                />
              </Form.Item>
            </Form>
          </Col>

          {profilePermissionService.hasPermission(
            "contracts-contracts:write"
          ) && (
            <Col
              lg={{ span: 4, offset: 8 }}
              md={{ span: 4, offset: 8 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Button
                type="primary"
                onClick={() => toPage("create")}
                size="large"
                block
              >
                Criar contrato
              </Button>
            </Col>
          )}
        </Row>

        <div className="contract">
          <div style={{ marginBottom: 16 }}>
            {customerId && (
              <Tag
                closable
                onClose={() => {
                  setCustomerId("");
                  formFilter.setFieldValue("filter_customer", undefined);
                  setCurrentPage(1);
                }}
              >
                Cliente:{" "}
                {customers?.find((c: any) => c.value === customerId)?.label}
              </Tag>
            )}
            {paymentMethod && (
              <Tag
                closable
                onClose={() => {
                  setPaymentMethod("");
                  formFilter.setFieldValue("filter_payment_method", undefined);
                  setCurrentPage(1);
                }}
              >
                Forma de Pagamento:{" "}
                {
                  paymentMethods.find((p: any) => p.value === paymentMethod)
                    ?.label
                }
              </Tag>
            )}
            {startDate && (
              <Tag
                closable
                onClose={() => {
                  setStartDate("");
                  formFilter.setFieldValue("filter_start_date", "");
                  setCurrentPage(1);
                }}
              >
                Data Início: {moment(startDate).format("DD/MM/YYYY")}
              </Tag>
            )}
            {endDate && (
              <Tag
                closable
                onClose={() => {
                  setEndDate("");
                  formFilter.setFieldValue("filter_end_date", "");
                  setCurrentPage(1);
                }}
              >
                Data Fim: {moment(endDate).format("DD/MM/YYYY")}
              </Tag>
            )}
          </div>

          <GenericTable
            columns={columns}
            dataSource={contracts}
            pagination={{
              current: currentPage,
              pageSize: perPage,
              showSizeChanger: true,
              total: total,
            }}
            loading={contractLoading}
            scroll={{ x: 1100 }}
            totalChildren={
              <div className="" style={isMobile ? {} : { marginTop: 8 }}>
                <Row>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    style={isMobile ? { marginBottom: 10, marginTop: 10 } : {}}
                  >
                    <ShowDataLength size={total} className="show_result_size" />
                  </Col>

                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    style={{
                      display: "flex",
                      justifyContent: isMobile ? "center" : "flex-end",
                    }}
                  >
                    <Space direction={isMobile ? "vertical" : "horizontal"}>
                      <FilterButton filters={filters} />

                      <ImportBtn
                        uploadFunction={importContracts}
                        block={isMobile}
                        multiple={false}
                        onSuccess={() => {
                          AlertService.sendAlert([
                            { text: "Importação concluída com sucesso." },
                          ]);

                          loadContracts();
                        }}
                      />

                      <ExportBtn
                        disabled={!total}
                        loading={exportIsLoading}
                        block={isMobile}
                        onClick={() => {
                          if (contractsToExport.length) {
                            exportData();
                          } else {
                            setExportIsLoading(true);
                            loadContractsToExport();
                          }
                        }}
                      />
                    </Space>
                  </Col>
                </Row>
              </div>
            }
            empty={{
              createTheFirst: !contracts.length && !search,
              textOne:
                "Esto contrato encontra-se vazia, uma vez que ainda não foram criados contratos.",
              textTwo: profilePermissionService.hasPermission(
                `contracts-contracts:write`
              )
                ? `Para começar, crie um novo contrato.`
                : "",
              link: profilePermissionService.hasPermission(
                `contracts-contracts:write`
              )
                ? `/contracts/create`
                : "",
              createText: "Criar contrato",
            }}
            handleTableChange={handleTableChange}
          />

          <DetailContract
            details={details}
            openDetails={openDetails}
            onCloseDetails={onCloseDetails}
          />

          <Modal
            open={openChangeStatus}
            title="Alterar status do contrato"
            okText="Alterar"
            cancelText="Voltar"
            confirmLoading={updateStatusLoading}
            onOk={onSubmitChangeStatus}
            onCancel={() => setOpenChangeStatus(false)}
          >
            <Form form={formChangeStatus} layout="vertical">
              <Form.Item
                label="Novo status"
                name="status"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Select
                  placeholder="Selecione o status"
                  options={contractsStatus}
                  size="large"
                />
              </Form.Item>

              <Form.Item
                label="Justificativa"
                name="status_reason"
                rules={[{ required: true, message: "Campo obrigatório" }]}
              >
                <Input.TextArea size="large" showCount maxLength={255} />
              </Form.Item>
            </Form>
          </Modal>

          <ConfirmModal
            open={!!removeContract}
            title={`Tem certeza que deseja apagar o contrato "${removeContract?.name}"?`}
            okText="Apagar"
            cancelText="Voltar"
            onOk={() => removeContractMutate(removeContract?.uuid)}
            onCancel={() => setRemoveContract(undefined)}
          ></ConfirmModal>
        </div>
      </Card>
    </>
  );
}
